import axios from "axios";
import GetServerAddress from "../../../functions/GetServerAddress";

export async function Upload_Photo_Consultant(
  base64,
  Photo_Type,
  Photo_Group,
  Attendee_ID,
  setState
) {
  const postData = async () => {
    try {
      const response = await axios.post(
        GetServerAddress() +
          "api/consultant/Upload_Photo_Consultant_To_MongoDB_By_ID",
        {
          myFile: base64,
          Photo_Type: Photo_Type,
          Photo_Group: Photo_Group,
          Attendee_ID: Attendee_ID,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("ConsultantToken")}`, // Include the JWT token in the request headers
            username: localStorage.getItem("Consultant_id"),
            activitylog: "Yes",
            aboutid: Attendee_ID,
          },
        }
      );
      console.log("Response Data: ", response);
      // Check for specific server response indicating an invalid auth token
      if (response.data.status === 403 || response.data.status === 401) {
        return; // Stop further execution in case of invalid auth token
      }
      //Failed
      if (response.data.status === 500) {
        window.alert(
          "Error Uploading Image, please refresh the page and try again. Then try lowering the quality/size of the image. Email us your image to if this issue persists"
        );
        return; // Stop further execution in case of invalid auth token
      }
      // Alert for successful POST request
      if (response.data.message === "Success") {
        setState((prevData) => ({ ...prevData, serverCheck: "Yes" }));
      }
    } catch (error) {
      console.error("Error Posting data: ", error);
      // Alert for failed POST request
      window.alert(
        "Error Posting data, please speak to InvestIN via info@investin.org if this issue persists: ",
        error
      );
    }
  };
  postData();
}
